import { Button, Card, CardBody, Col, Container, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap'
import DataTable, { TableColumn } from "react-data-table-component";
// import CollapseFilterData from './CollapseFilterData';
import { useEffect, useMemo, useState } from 'react';
import { SearchTableButton } from '../../../../utils/Constant';
import api from '../../../../utils/api';
import Swal from 'sweetalert2';
import { CategoryTableDataColumnType } from '../../../../Types/Application/Ecommerce/Ecommerce';
import { CategoryTableAction, CategoryTableOfferComponent } from '../../../../Types/Application/Ecommerce/CategoryList';
import CategoryListFilterHeader from './CategoryListFilterHeader';
import { SVG } from '../../../../AbstractElements';

const CategoryListContainer = () => {
  const [editData, setEditData] = useState<any>(null);
    const [editModalOpen, setEditModalOpen] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [CategoryListTableDatas, setCategoryListTableDatas] = useState<CategoryTableDataColumnType[]>([]);

  // Pagination-related states
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);

    const fetchCategory = async (page: number, size: number) => {
        try {
          setLoading(true);

          const response = await api.get(
            `api/FoodCategory/GetAllFoodCategoryPagination?pageNumber=${page}&pageSize=${size}`
          );
          if (response.status === 200) {
            setCategoryListTableDatas(
              response.data.items.map((item: {foodCategoryId: number; categoryName: string; }) => ({
                foodCategoryId: item.foodCategoryId,
                categoryName: item.categoryName,
              }))
            );

            // Set total record count from backend
            setTotalRows(response.data.totalCount);
          }
        } catch (error) {
          console.error("Failed to fetch Category:", error);
        } finally {
          setLoading(false);
        }
      };

    useEffect(() => {
      fetchCategory(currentPage, pageSize);
    }, [currentPage, pageSize]);

    const handleDelete = async (id: number) => {
      try {
        await api.delete(`/api/FoodCategory/DeleteFoodCategoryById?foodCategoryId=${id}`);
       Swal.fire('Deleted!', 'Category has been deleted.', 'success');
    
        // Refresh current page data
        await fetchCategory(currentPage, pageSize);
      } catch (error) {
        Swal.fire('Error!', 'Failed to delete the category.', 'error');
        console.error("Delete error:", error);
      }
    };

    const handleEdit = (row: any) => {
        setEditData(row);
        setEditModalOpen(true);
      };
    
      const handleEditChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEditData({ ...editData, [e.target.name]: e.target.value });
      };
    
      const handleEditSave = async () => {
        if (!editData || !editData.foodCategoryId || !editData.categoryName) {
          Swal.fire("Error!", "Please fill all fields before saving.", "error");
          return;
        }
        if (editData.categoryName.trim() === "") {
          Swal.fire("Error!", "Category name cannot be empty.", "error");
          return;
        }
        try {
          await api.put(`/api/FoodCategory/UpdateFoodCategoryById`, {
            foodCategoryId: editData.foodCategoryId,
            categoryName: editData.categoryName,
          });

          // Refresh current page data
          await fetchCategory(currentPage, pageSize);

          setEditModalOpen(false);
          Swal.fire("Updated!", "Category has been updated.", "success");
        } catch (error) {
          Swal.fire("Error!", "Failed to update the category.", "error");
        }
      };


    const CategoryListTableDataColumn: TableColumn<CategoryTableDataColumnType>[] = [
        {
        name: "Name",
        cell: (row) => <CategoryTableOfferComponent title={String(row.categoryName)}/>,
        sortable: true,
        grow: 2,
        },
        {
          name: "Action",
          cell: (row) => 
          (
            <><span
              onClick={() => handleEdit(row)}
              title="Edit"
              style={{ cursor: "pointer" }}
            >
              <SVG
                iconId="edit-content"
                style={{ fill: "blue", width: 18, height: 18 }} />
            </span><CategoryTableAction foodCategoryId={row.foodCategoryId} onDelete={handleDelete} /></>
          ),
        },
    ];

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage: number, page: number) => {
    setPageSize(newPerPage);
    setCurrentPage(page);
  };

  const filteredItems = CategoryListTableDatas.filter((item: { categoryName: any; }) => item.categoryName && String(item.categoryName).toLowerCase().includes(filterText.toLowerCase()));

  const subHeaderComponentMemo = useMemo(() => {
    return (
      <div className="dataTables_filter d-flex align-items-center">
        <Label className="me-2">{SearchTableButton}:</Label>
        <Input onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)} type="search" value={filterText} />
      </div>
    );
  }, [filterText]);

  return (
    <Container fluid>
      <Row>
        <Col sm="12">
          <Card>
            <CardBody>
              <div className="list-product-header">
                <CategoryListFilterHeader />
                {/* <CollapseFilterData /> */}
              </div>
              <div className="list-product">
                <div className="table-responsive">
                  <DataTable
                    data={filteredItems}
                    columns={CategoryListTableDataColumn}
                    striped
                    highlightOnHover
                    pagination
                    paginationServer
                    paginationTotalRows={totalRows}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handlePerRowsChange}
                    paginationDefaultPage={currentPage}
                    paginationPerPage={pageSize}
                    progressPending={loading}
                    selectableRows
                    subHeader
                    subHeaderComponent={subHeaderComponentMemo}
                  />
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Modal
        isOpen={editModalOpen}
        toggle={() => setEditModalOpen(!editModalOpen)}
      >
        <ModalHeader toggle={() => setEditModalOpen(!editModalOpen)}>
          Edit Category
        </ModalHeader>
        <ModalBody>
          {editData && (
            <>
              <FormGroup>
                <Label>Category Name</Label>
                <Input
                  name="categoryName"
                  value={editData.categoryName}
                  onChange={handleEditChange}
                  required={true}
                />
              </FormGroup>
            </>
                )}
              </ModalBody>
              <ModalFooter>
                <Button color="secondary" onClick={() => setEditModalOpen(false)}>
                  Cancel
                </Button>
                <Button color="primary" onClick={handleEditSave}>
                  Save
                </Button>
              </ModalFooter>
            </Modal>
    </Container>
  )
}

export default CategoryListContainer